import { Tool } from '@services/tools';

export abstract class JournalTool extends Tool {
  protected _isEnabled: boolean;
  get isEnabled(): boolean {
    return this._isEnabled;
  }
}
